import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface LibraryCategoriesState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allLibraryCategories: any[] | null;
  searchResults: any[] | null;
  groupedLibraryCategories: any[] | null;
}

const initialState: LibraryCategoriesState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allLibraryCategories: null,
  searchResults: null,
  groupedLibraryCategories: null,
};

export const libraryCategoriesSlice = createSlice({
  name: 'LibraryCategories',
  initialState,
  reducers: {
    // For paginated fetch (default listing)
    setLibraryCategories: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
      state.searchResults = null; // clear search results on normal fetch
    },

    // For fetching all categories (if needed for dropdowns, etc.)
    setAllLibraryCategories: (state, action) => {
      state.allLibraryCategories = action.payload;
    },

    setGroupedLibraryCategories: (state, action) => {
      state.groupedLibraryCategories = action.payload;
    },

    // For search results
    setLibraryCategoriesBySearch: (state, action) => {
      state.searchResults = action.payload.data.data;
      state.totalRecords = action.payload.totalRecords;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
    },

    // Reset all state
    reset: () => initialState,
  },
});

// Action creators
export const {
  setLibraryCategories,
  setLibraryCategoriesBySearch,
  setAllLibraryCategories,
  reset,
  setGroupedLibraryCategories,
} = libraryCategoriesSlice.actions;

// Selectors
export const getLibraryCategoriesDetails = (state: RootState) => state.libraryCategories.data;
export const getLibraryCategoriesBySearch = (state: RootState) => state.libraryCategories.searchResults;
export const getAllLibraryCategoriesDetails = (state: RootState) => state.libraryCategories.allLibraryCategories;
export const getLibraryCategoriesTotalRecords = (state: RootState) => state.libraryCategories.totalRecords;
export const getLibraryCategoriesTotalPages = (state: RootState) => state.libraryCategories.totalPages;
export const getLibraryCategoriesCurrentPage = (state: RootState) => state.libraryCategories.currentPage;
export const getGroupedLibraryCategories = (state: RootState) => state.libraryCategories.groupedLibraryCategories;


export default libraryCategoriesSlice.reducer;
